import React from "react";

function Hero() {
  return (
    <header
      id="home"
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0 10%',
        position: 'relative',
        overflow: 'hidden',
        zIndex: 1,
      }}
    >
      <div className="hero-content" style={{ position: 'relative', zIndex: 2 }}>
        <h1
        className="hero-title gs_hero"
        style={{
          fontSize: '6rem',
          fontWeight: 900,
          lineHeight: 1.05,
          marginBottom: '1.5rem',
        }}
      >
        Architecting<br />
        <span style={{ color: '#00ffcc' }}>Digital Reality.</span>
      </h1>

      <p
        className="gs_hero"
        style={{
          fontSize: '1.2rem',
          color: '#aaaaaa',
          maxWidth: '600px',
          marginBottom: '3rem',
          lineHeight: 1.6,
        }}
      >
        CloudNest is a premier development agency specializing in highly-scalable
        web architecture, immersive 3D interfaces, and cloud-native software solutions.
      </p>

        <div className="gs_hero" style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', position: 'relative', zIndex: 3 }}>
          <a href="#work" className="cta-btn-solid">View Our Work</a>
          <a href="#contact" className="cta-btn">Contact Us</a>
        </div>
      </div>
    </header>
  );
}

export default Hero;


